import { Box, Typography, styled } from "@mui/material";
import React from "react";

import { useBrand } from "src/hooks/useBrand";

import { ariaLabel } from "../../constants";

const StyledContainer = styled("div")`
  display: flex;
  flex: 1;
  align-items: center;
`;

const StyledForm = styled("form")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 600px;
  min-height: 600px;
  margin-top: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.palette.common.white};
  border-radius: ${(props) => props.theme.spacing(2)};
  overflow: hidden;
  padding: ${(props) => props.theme.spacing(4)};

  ${(props) => props.theme.breakpoints.down("sm")} {
    width: calc(100vw - ${(props) => props.theme.spacing(2)});
    padding: ${(props) => props.theme.spacing(2)};
  }
`;

type Props = {
  title?: string | null;
  children: React.ReactNode;
};

export const AuthBox = ({ title: defaultTitle, children }: Props) => {
  const { customerPortal, identity } = useBrand();

  const title = defaultTitle ?? `Bienvenue sur ${customerPortal.name} !`;

  return (
    <StyledContainer>
      <Box aria-label={ariaLabel.main} role="main" id="main" component="main">
        <StyledForm>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img src={identity.logoUrl} width={170} alt={identity.name} />
          </Box>
          {title && (
            <Typography
              id="auth-box-title"
              variant="h6"
              color="secondary"
              textAlign="center"
              fontWeight="bold"
              sx={{ textAlign: "center", mb: 2, mt: 1 }}
            >
              {title}
            </Typography>
          )}
          {children}
        </StyledForm>
      </Box>
    </StyledContainer>
  );
};
